import { createContext } from "react";
import { MultiplayerEventType } from "../../types/Multiplayer.types";
import ReconnectingWebSocket from "reconnecting-websocket";

export type SocketEventHandler = (payload: any) => void;

export type MultiplayerContextType = {
  loading: boolean;
  socket: ReconnectingWebSocket | null;
  isConnected: boolean;
  addEventListener: (
    eventType: MultiplayerEventType,
    handler: SocketEventHandler
  ) => void;
  removeEventListener: (
    eventType: MultiplayerEventType,
    handler: SocketEventHandler
  ) => void;
  // Subscription methods
  subscribeToDesign: (designId: string | null) => Promise<void>;
  unsubscribeFromDesign: () => Promise<void>;
  subscribeToProject: (projectId: string | null) => Promise<void>;
  unsubscribeFromProject: () => Promise<void>;
  subscribeToTeam: (teamId: string | null) => Promise<void>;
  unsubscribeFromTeam: () => Promise<void>;
  sendCursorPosition: (
    designId: string | null,
    coordinates: { x: number; y: number; side: string }
  ) => Promise<void>;
};

export const MultiplayerContext = createContext<MultiplayerContextType>({
  loading: true,
  socket: null,
  isConnected: false,
  addEventListener: () => {},
  removeEventListener: () => {},
  subscribeToDesign: async () => {},
  unsubscribeFromDesign: async () => {},
  subscribeToProject: async () => {},
  unsubscribeFromProject: async () => {},
  subscribeToTeam: async () => {},
  unsubscribeFromTeam: async () => {},
  sendCursorPosition: async () => {},
});
